import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import genderService from "./genderService";

const initialState = {
  gender: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//Edit Gender
export const editGender = createAsyncThunk(
  "gender/edit",
  async (genderData, thunkAPI) => {
    try {
      return await genderService.editGender(genderData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



// Get Gender
export const getGender = createAsyncThunk(
  "Gender/get",
  async (thunkAPI) => {
    try {
      //console.log("In getSchools slice getAll");

      return await genderService.getGender();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const genderSlice = createSlice({
  name: "Gender",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(editGender.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editGender.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.gender.push(action.payload);
      })
      .addCase(editGender.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getGender.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGender.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.gender = action.payload;
      })
      .addCase(getGender.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
  },
});

export const { reset } = genderSlice.actions;
export default genderSlice.reducer;
